export default {
  'actions.title': 'ACCIONES',
  'actions.search': 'Busca una Acción',
  'actions.description.defaultInitial': 'Acción inicial del proceso',
  'actions.description.completeInformation': 'Permite completar información mediante formularios',
  'config.form.isInitialForm': '¿Formulario Inicial?',
  'config.form.isHeaderDetailsVisible': '¿Detalles de Cabecera Visible?',
  'config.form.isVisibleInDetails': '¿Visible en vista detalle de solicitud?',
  'actions.form.isInitialAction': '¿Acción Inicial?',
  'actions.form.isAutoOpenEditOperationEnabled': '¿Abrir Automáticamente Operación Editar',
  'actions.form.saveButtonDisabled': '¿Ocultar Botón Guardar?',
  'actions.form.cancelButtonDisabled': '¿Ocultar Botón Cancelar?',
  'actions.form.allowedAppClient': 'Aplicación Permitida',
  'actions.form.emailServerConfiguration': 'Servidor de Correo',

  'actions.form.name': 'Nombre',
  'actions.form.description': 'Descripción',
  'actions.form.displayTitle': 'Título a Mostrar',
  'actions.form.enabled': '¿Elemento Habilitado?',
  'actions.form.completeInformationForm': 'Formulario Completar Información',
  'actions.form.nextAction': 'Siguiente Acción',
  'actions.form.form': 'Formulario',
  'actions.form.field': 'Campo',
  'actions.form.users': 'Usuarios',
  'actions.form.positions': 'Puestos',
  'actions.form.areas': 'Áreas',
  'actions.form.userGroups': 'Grupos de Usuarios',
  'actions.form.aiAgents': 'Agentes',
  'actions.form.parentParallelAction': 'Acción Paralela Padre',
  'actions.form.parentParallelFlow': 'Flujo Paralelo Padre',
  'actions.form.parentIterateAction': 'Acción Iteración Padre',
  'actions.form.isRejectControlEnabled': '¿Control de Rechazo Habilitado?',
  'actions.form.nextActionIfFalseId': 'Siguiente Acción(No)',
  'actions.form.maxRejectionCount': 'Máximo Número de Rechazos',
  'actions.form.minNumberOfRejections': 'Mínimo Número de Rechazos',
  'actions.form.isTooltipEnabled': '¿Tooltip Habilitado?',
  'actions.form.tooltip': 'Tooltip',
  'actions.form.isPDFGenerationEnabled': '¿Generación de PDF Habilitada?',
  'actions.form.isNotificationsEnabled': '¿Notificaciones Habilitadas?',
  'actions.form.isPDFAttachmentEnabled': '¿Adjuntar PDF en Correos?',
  'actions.form.notificationsFrequency': 'Frecuencia de Notificaciones',
  'actions.form.frequencyValue': 'Valor Frecuencia',
  'actions.form.isWebhookEnabled': '¿Webhook Habilitado?',
  'actions.form.isWebhookCurrentStepValidationEnabled': '¿Validar Paso Actual?',
  'actions.form.isInternalExecutionAllowed': '¿Permitir Ejecución Interna?',
  'actions.form.webhookUser': 'Usuario Operaciones Webhook',
  'actions.form.webApiConnection': 'Conexión API',
  'actions.form.connection': 'Conexión API',
  'actions.form.databaseConnection': 'Conexión Base de Datos',
  'actions.form.reason': 'Motivo',
  'actions.form.logicalOperator': 'Operador Lógico',
  'actions.form.databaseQuery': 'Consulta Base de Datos',
  'actions.form.dynamicEntity': 'Entidad Dinámica',
  'actions.form.dynamicEntityOperation': 'Operación',
  'actions.form.iterationDataSource': 'Origen de Datos Iteración',
  'actions.form.iterationForm': 'Formulario',
  'actions.form.iterationTableField': 'Tabla',
  'actions.form.iterationFormField': 'Campo de formulario',
  'actions.form.iterationDynamicEntity': 'Entidad dinámica',
  'actions.form.iterationDynamicEntityFieldItemDisplayField': 'Campo de visualización',
  'actions.form.iterationDynamicEntityFieldItemGroupByField': 'Campo de agrupación',
  'actions.form.itemsAffected': 'Elementos Afectados',
  'actions.form.customItemsAffectedNumber': 'Cantidad de Elementos',
  'actions.form.operationEntity': 'Entidad',
  'actions.form.operation': 'Operación',
  'actions.form.fileFormat': 'Formato',
  'actions.form.textSeparator': 'Separador',
  'actions.form.writeHeader': '¿Escribir Cabecera?',
  'actions.form.readHeader': '¿Leer Cabecera?',
  'actions.form.xmlWriteDocumentTypeDefinition': '¿Escribir DTD XML?',
  'actions.form.xmlRootTagText': 'Etiqueta Elemento Raíz',
  'actions.form.xmlElementTagText': 'Etiqueta Elemento',
  'actions.form.documentSourceForm': 'Formulario',
  'actions.form.documentSourceField': 'Campo Adjunto',
  'actions.form.startRow': 'Fila Inicial',
  'actions.form.handlerType': 'Tipo de Manejador IA',
  'actions.form.reasoningEffort': 'Esfuerzo de Razonamiento',
  'actions.form.reasoningSummary': 'Resumen de Razonamiento',
  'actions.form.agent': 'Agente IA',
  'actions.form.fieldBehavior': 'Comportamiento',
  'actions.form.command': 'Comando',
  'actions.form.commandBehavior': 'Comportamiento de Comando',
  'actions.form.order': 'Orden',
  'actions.form.fieldType': 'Tipo de Campo',
  'actions.form.conditionGroups': 'Condiciones (JSON)',

  // DynamicEntityOperation
  'actions.form.select.Search': 'Búsqueda',
  'actions.form.select.Add': 'Adicionar',
  'actions.form.select.Modify': 'Modificar',
  'actions.form.select.Remove': 'Eliminar',
  'actions.form.select.Count': 'Contar',
  'actions.form.select.Sum': 'Sumar',
  'actions.form.select.Subtraction': 'Restar',
  'actions.form.select.Increment': 'Incrementar',
  'actions.form.select.Decrement': 'Decrementar',
  'actions.form.select.EvaluateFormula': 'Evaluar Fórmula',
  'actions.form.select.allCurrentChildren': 'Todos los hijos actuales',
  'actions.form.select.childrenStartedBySpecificAction':
    'Hijos iniciados por una acción específica',
  'actions.form.select.untilChildrenFinish': 'Hasta que los hijos terminen',
  'actions.form.select.untilChildrenCompleteSpecificAction':
    'Hasta que los hijos completen una acción específica',
  'actions.form.select.behaviorContinue': 'Continuar',
  'actions.form.select.behaviorThrowError': 'Lanzar error',
  'actions.form.select.continueAlways': 'Continuar siempre',
  'actions.form.select.throwErrorIfAnyFailed': 'Lanzar error si alguno falló',
  'actions.form.select.throwErrorIfAllFailed': 'Lanzar error si todos fallaron',

  // SearchResultGroupingMode
  'actions.form.select.None': 'Ninguno',
  'actions.form.select.ResponseMapping': 'Mapeo de Respuesta',

  // SearchResultAllocationMode
  'actions.form.select.Ordered': 'Ordenado',
  'actions.form.select.Random': 'Aleatorio',

  // ColumnOrderDirection
  'actions.form.select.Ascending': 'Ascendente',
  'actions.form.select.Descending': 'Descendente',

  // ItemsAffected
  'actions.form.select.All': 'Todos',
  'actions.form.select.One': 'Uno',
  'actions.form.select.Custom': 'Personalizado',
  'actions.form.select.FormTable': 'Tabla de Formulario',
  'actions.form.select.DynamicEntity': 'Entidad Dinámica',
  'actions.form.select.FormFieldAttachment': 'Adjunto de Campo',
  'actions.form.select.Activate': 'Activar',
  'actions.form.select.Deactivate': 'Desactivar',
  'actions.form.select.CancelDelegation': 'Cancelar Delegación',
  'actions.form.select.User': 'Usuario',
  'actions.form.select.Position': 'Puesto',
  'actions.form.select.Area': 'Área',
  'actions.form.select.UserGroup': 'Grupo de Usuarios',
  'actions.form.select.UserGroupUser': 'Usuario de Grupo',
  'actions.form.select.Environment': 'Entorno',
  'actions.form.select.EnvironmentUser': 'Usuario de Entorno',
  'actions.form.select.Delegation': 'Delegación',
  'actions.form.select.DelegationConfiguration': 'Configuración Delegación',
  'actions.form.select.GlobalEntityApproverByAreas': 'Aprobadores Entidad por Áreas',
  'actions.form.select.GlobalEntityApproverByPositions': 'Aprobadores Entidad por Puestos',
  'actions.form.select.GlobalEntityApproverByUserGroups': 'Aprobadores Entidad por Grupos',
  'actions.form.select.GlobalEntityApproverUsers': 'Aprobadores Entidad por Usuarios',
  'actions.form.select.GlobalUserGroupApproverByAreas': 'Aprobadores Grupo por Áreas',
  'actions.form.select.GlobalUserGroupApproverByPositions': 'Aprobadores Grupo por Puestos',
  'actions.form.select.GlobalUserGroupApproverUsers': 'Aprobadores Grupo por Usuarios',
  'actions.form.select.ReportTrace': 'Trazas',
  'actions.form.select.ProcessInstance': 'Instancia de Proceso',
  'actions.form.select.ChatThreadParticipant': 'Participante de Chat',
  'actions.form.select.Json': 'JSON',
  'actions.form.select.Text': 'Texto',
  'actions.form.select.Csv': 'CSV',
  'actions.form.select.Xml': 'XML',
  'actions.form.select.Parquet': 'Parquet',
  'actions.form.select.Agent': 'Agente',
  'actions.form.select.Responses': 'Respuestas',
  'actions.form.select.Parser': 'Parser',
  'actions.form.select.Generic': 'Genérico',
  'actions.form.select.UploadFile': 'Subir Archivo',
  'actions.form.select.DownloadFile': 'Descargar Archivo',
  'actions.form.select.GoogleDrive': 'Google Drive',
  'actions.form.select.SendMessage': 'Enviar Mensaje',
  'actions.form.select.Python': 'Python',
  'actions.form.select.Concise': 'Conciso',
  'actions.form.select.Detailed': 'Detallado',
  'actions.form.select.Auto': 'Automático',
  'actions.form.select.Minimal': 'Mínimo',
  'actions.form.select.Low': 'Bajo',
  'actions.form.select.Medium': 'Medio',
  'actions.form.select.High': 'Alto',
  'actions.form.select.ReadOnly': 'Solo lectura',
  'actions.form.select.Hidden': 'Oculto',
  'actions.form.select.Visible': 'Visible',
  'actions.form.select.Required': 'Requerido',
  'actions.form.select.NotRequired': 'No requerido',
  'actions.form.select.VisibleAndSkipFormulaEvaluation': 'Visible y omitir fórmula',
  'actions.form.select.HiddenAndSkipFormulaEvaluation': 'Oculto y omitir fórmula',
  'actions.form.select.Locked': 'Bloqueado',
  'actions.form.select.Edit': 'Editar',
  'actions.form.select.Delete': 'Eliminar',
  'actions.form.select.Import': 'Importar',
  'actions.form.select.Export': 'Exportar',
  'actions.form.select.Clear': 'Limpiar',
  'actions.form.select.Allow': 'Permitir',
  'actions.form.select.Denied': 'Denegado',

  'actions.config.configurations': 'Configuraciones',
  'actions.config.approval': 'Aprobación',
  'actions.config.action-approval-general': 'Generales',
  'actions.config.action-approval-rejection': 'Rechazo',
  'actions.config.action-approval-deadline': 'Límite de Tiempo',
  'actions.config.action-approval-filters': 'Filtros',
  'actions.config.action-approval-filters-general': 'Generales',
  'actions.config.action-approval-filters-users': 'Usuarios',
  'actions.config.action-approval-filters-positions': 'Puestos',
  'actions.config.action-approval-filters-areas': 'Áreas',
  'actions.config.action-approval-filters-user-groups': 'Grupos de Usuarios',
  'actions.config.action-approval-filters-external-users': 'Usuarios Externos',
  'actions.config.action-approval-filters-agents': 'Agentes',
  'actions.config.action-approval-filters-user-extra-fields': 'Campos Extra Usuario',
  'actions.config.action-approval-filters-global-approvers': 'Filtros Globales de Aprobadores',
  'actions.config.action-approval-filters-form-field-user-approvers':
    'Filtros por Campos de Formulario',
  'actions.config.custom-notifications': 'Notificaciones Personalizadas',
  'actions.config.notifications-mapping-attachments': 'Notificaciones / Mapeos Adjuntos',
  'actions.config.email-template': 'Formato de Correo',
  'actions.config.pdf-template-generation-mapping': 'Mapeos Generación Formatos',
  'actions.config.form-complete-information': 'Formulario Completar Información',
  'actions.config.digital-signature-field-mapping': 'Mapeo Campos Firma Digital',
  'actions.config.response-status': 'Mapeo Código Respuesta Http / Acción Siguiente',
  'actions.config.api-call-send': 'Mapeos Envío API',
  'actions.config.api-call-response': 'Mapeos Respuesta API',
  'actions.config.webhook-mapping': 'Mapeos Parámetros Webhook',
  'actions.config.set-variable': 'Establecer Variables',
  'actions.config.set-form-field-value': 'Establecer Datos de Formularios',
  'actions.config.conditional': 'Condicional',
  'actions.config.execute-process-action': 'Mapeos',
  'actions.config.switch': 'Casos',
  'actions.config.parallel': 'Ramas',
  'actions.config.run-code': 'Mapeos de respuesta',
  'actions.config.start-process-instance': 'Mapeos',
  'actions.config.integration': 'Mapeos',
  'actions.config.execute-rpa-flow': 'Mapeos',
  'actions.config.consume-sequence': 'Mapeos',
  'actionMapping.sendMappings': 'Mapeos de envío',
  'actionMapping.responseMappings': 'Mapeos de respuesta',
  'actionMapping.resultMappings': 'Mapeos de resultado',
  'actionMapping.item': 'Mapeo',
  'actionMapping.add': 'Agregar mapeo',
  'actionMapping.customSendJsonBody': 'Cuerpo JSON de envío personalizado',
  'actions.config.action-entity-operation': 'Operación Entidad',
  'actions.config.action-scheduled-execution': 'Programación',
  'actions.config.action-webhook-general': 'Webhook (General)',
  'actions.config.action-behaviors': 'Comportamientos',
  'actions.config.set-form-data': 'Establecer Datos de Formularios',
  'actions.config.action-iteration': 'Iteración',
  'actions.config.action-internal-operation': 'Operación Interna',
  'actions.config.action-generate-plain-text-file': 'Formato Fichero',
  'actions.config.action-import-plain-text-file': 'Formato Fichero',
  'actions.config.action-automy-ai': 'Operación IA',
  'actions.config.action-behaviors-fields': 'Comportamientos - Campos',
  'actions.config.action-behaviors-commands': 'Comportamientos - Comandos',

  'actions.form.minimumNumberOfApprovers': 'Mínimo Número de Aprobadores',
  'actions.form.isRejectionDisabled': '¿Rechazo Deshabilitado?',
  'actions.form.isCompletedOptionDisabled': '¿Desabilitar Botón Completar?',
  'actions.form.webhookToken': 'Url Webhook',

  'actions.form.isErrorControlEnabled': '¿Habilitar Control de Errores?',
  'actions.form.nextActionIfErrorId': 'Siguiente Acción (Error)',
  'actions.form.errorValueDestination': 'Destino Error',
  'actions.form.errorVariableDestinationId': 'Error - Variable Destino',
  'actions.form.errorFormDestinationId': 'Error - Formulario Destino',
  'actions.form.errorFieldDestinationId': 'Error - Campo Destino',

  'actions.form.filtersLogicalOperator': 'Operador Lógico para Filtros',
  'actions.form.filtersUserGroupsLogicalOperator': 'Operador Lógico para Grupos',

  'actions.form.isDeadlineEnabled': '¿Habilitar Control de Límite de Tiempo de Ejecución?',
  'actions.form.deadlineMeasureUnit': 'Unidad de Control de Tiempo',
  'actions.form.deadlineMeasureValue': 'Valor de Control de Tiempo',
  'actions.form.overdueOperation': 'Operación',
  'actions.form.nextActionIfOverdueId': 'Acción Siguiente',
  'actions.form.overdueOperationObservations': 'Observaciones',

  'actions.form.isTwoFactorApprovalEnabled': '¿Aprobación Two-Factor?',
  'actions.form.isForApplicantApprovalEnabled': '¿Aprobar por el Solicitante?',
  'actions.form.isApprovalByExternalUserEnabled': '¿Habilitar Aprobación por Usuario Externo?',
  'actions.form.isPositionEqualToApplicantPosition': '¿Filtrar por Puesto del Solicitante?',
  'actions.form.isAreaEqualToApplicantArea': '¿Filtrar por Área del Solicitante?',
  'actions.form.isForApplicantBossApprovalEnabled': '¿Aprobar por el Jefe del Solicitante?',
  'actions.form.isApproveByTheLastApproverEnabled': '¿Aprobar por Último Aprobador?',

  'actions.form.isGlobalUserGroupApproversFilterEnabled':
    '¿Habilitar Filtro Global de Aprobadores por Grupos de Usuarios?',
  'actions.form.globalUserGroupFilterFormId':
    'Formulario para Filtro Global de Aprobadores por Grupos de Usuarios',
  'actions.form.globalUserGroupFilterFieldId':
    'Campo para Filtro Global de Aprobadores por Grupos de Usuarios',
  'actions.form.isGlobalUserGroupApproversFilterApprovalLevelEnabled':
    '¿Habilitar Nivel de Filtro Global de Aprobadores por Grupos de Usuarios?',
  'actions.form.globalUserGroupApproversFilterApprovalLevel':
    'Nivel de Filtro Global de Aprobadores por Grupos de Usuarios',

  'actions.form.isGlobalUserGroupPositionApproversFilterEnabled':
    '¿Habilitar Filtro Global de Aprobadores por Grupos de Usuarios y Puestos?',
  'actions.form.globalUserGroupFilterPositionFormId':
    'Formulario para Filtro Global de Aprobadores por Grupos de Usuarios y Puestos',
  'actions.form.globalUserGroupFilterPositionFieldId':
    'Campo para Filtro Global de Aprobadores por Grupos de Usuarios y Puestos',
  'actions.form.isGlobalUserGroupPositionApproversFilterApprovalLevelEnabled':
    '¿Habilitar Nivel de Filtro Global de Aprobadores por Grupos de Usuarios y Puestos?',
  'actions.form.globalUserGroupPositionApproversFilterApprovalLevel':
    'Nivel de Filtro Global de Aprobadores por Grupos de Usuarios y Puestos',

  'actions.form.isGlobalUserGroupAreaApproversFilterEnabled':
    '¿Habilitar Filtro Global de Aprobadores por Grupos de Usuarios y Áreas?',
  'actions.form.globalUserGroupFilterAreaFormId':
    'Formulario para Filtro Global de Aprobadores por Grupos de Usuarios y Áreas',
  'actions.form.globalUserGroupFilterAreaFieldId':
    'Campo para Filtro Global de Aprobadores por Grupos de Usuarios y Áreas',
  'actions.form.IsGlobalEntityApproversByAreaFilterApprovalLevelEnabled':
    '¿Habilitar Nivel de Filtro Global de Aprobadores por Grupos de Usuarios y Áreas?s',
  'actions.form.globalUserGroupAreaApproversFilterApprovalLevel':
    'Nivel de Filtro Global de Aprobadores por Grupos de Usuarios y Áreas',

  'actions.form.isGlobalEntityApproversFilterEnabled':
    '¿Habilitar Filtro Global de Aprobadores por Entidades y Usuarios?',
  'actions.form.globalEntityFilterFormId':
    'Formulario para Filtro Global de Aprobadores por Entidades',
  'actions.form.globalEntityFilterFieldId': 'Campo para Filtro Global de Aprobadores por Entidades',
  'actions.form.isGlobalEntityApproversFilterApprovalLevelEnabled':
    '¿Habilitar Nivel de Filtro Global de Aprobadores por Entidades?',
  'actions.form.globalEntityApproversFilterApprovalLevel':
    'Nivel de Filtro Global de Aprobadores por Entidades',

  'actions.form.isGlobalEntityApproversByUserGroupFilterEnabled':
    '¿Habilitar Filtro Global de Aprobadores por Entidades y Grupos de Usuarios?',
  'actions.form.globalEntityFilterByUserGroupFormId':
    'Formulario para Filtro Global de Aprobadores por Entidades y Grupos de Usuarios',
  'actions.form.globalEntityFilterByUserGroupFieldId':
    'Campo para Filtro Global de Aprobadores por Entidades y Grupos de Usuarios',
  'actions.form.isGlobalEntityApproversByUserGroupFilterApprovalLevelEnabled':
    '¿Habilitar Nivel de Filtro Global de Aprobadores por Entidades y Grupos de Usuarios?',
  'actions.form.globalEntityApproversByUserGroupFilterApprovalLevel':
    'Nivel de Filtro Global de Aprobadores por Entidades y Grupos de Usuarios',

  'actions.form.isGlobalEntityApproversByPositionFilterEnabled':
    '¿Habilitar Filtro Global de Aprobadores por Entidades y Puestos?',
  'actions.form.globalEntityFilterByPositionFormId':
    'Formulario para Filtro Global de Aprobadores por Entidades y Puestos',
  'actions.form.globalEntityFilterByPositionFieldId':
    'Campo para Filtro Global de Aprobadores por Entidades y Puestos',
  'actions.form.isGlobalEntityApproversByPositionFilterApprovalLevelEnabled':
    '¿Habilitar Nivel de Filtro Global de Aprobadores por Entidades y Puestos?',
  'actions.form.globalEntityApproversByPositionFilterApprovalLevel':
    'Nivel de Filtro Global de Aprobadores por Entidades y Puestos',

  'actions.form.isGlobalEntityApproversByAreaFilterEnabled':
    '¿Habilitar Filtro Global de Aprobadores por Entidades y Áreas?',
  'actions.form.globalEntityFilterByAreaFormId':
    'Formulario para Filtro Global de Aprobadores por Entidades y Áreas',
  'actions.form.globalEntityFilterByAreaFieldId':
    'Campo para Filtro Global de Aprobadores por Entidades y Áreas',
  'actions.form.IsGlobalEntityApproversByAreaFilterApprovalLevelEnabled':
    '¿Habilitar Nivel de Filtro Global de Aprobadores por Entidades y Áreas?',
  'actions.form.globalEntityApproversByAreaFilterApprovalLevel':
    'Nivel de Filtro Global de Aprobadores por Entidades y Áreas',

  'actions.form.isApproverByUserFormFieldFilterEnabled':
    '¿Habilitar Filtro de Usuario por Campo de Formulario?',
  'actions.form.approverByUserFormFieldFormId':
    'Formulario para Filtro de Usuario por Campo de Formulario',
  'actions.form.approverByUserFormFieldFieldId':
    'Campo para Filtro de Usuario por Campo de Formulario',

  'actions.form.isApproverByPositionFormFieldFilterEnabled':
    '¿Habilitar Filtro de Usuario por Campo Puesto de Formulario?',
  'actions.form.approverByPositionFormFieldFormId':
    'Formulario para Filtro de Usuario por Campo Puesto de Formulario',
  'actions.form.approverByPositionFormFieldFieldId':
    'Campo para Filtro de Usuario por Campo Puesto de Formulario',

  'actions.form.isApproverByAreaFormFieldFilterEnabled':
    '¿Habilitar Filtro de Usuario por Campo Área de Formulario?',
  'actions.form.approverByAreaFormFieldFormId':
    'Formulario para Filtro de Usuario por Campo Área de Formulario',
  'actions.form.approverByAreaFormFieldFieldId':
    'Campo para Filtro de Usuario por Campo Área de Formulario',

  'actions.form.isApproverByUserGroupFormFieldFilterEnabled':
    '¿Habilitar Filtro de Usuario por Campo Grupo de Usuarios de Formulario?',
  'actions.form.approverByUserGroupFormFieldFormId':
    'Formulario para Filtro de Usuario por Campo Grupo de Usuarios de Formulario',
  'actions.form.approverByUserGroupFormFieldFieldId':
    'Campo para Filtro de Usuario por Campo Grupo de Usuarios de Formulario',

  'action.config.select.ReadOnly': 'Solo Lectura',
  'action.config.select.Hidden': 'Oculto',
  'action.config.select.Visible': 'Visible',
  'action.config.select.Required': 'Requerido',
  'action.config.select.NotRequired': 'No Requerido',
  'action.config.select.VisibleAndSkipFormulaEvaluation': 'Visible and Skip Formula Evaluation',
  'action.config.select.HiddenAndSkipFormulaEvaluation': 'Oculto y Omitir Evaluación de Fórmula',

  'action.config.select.formField': 'Formulario / Campo',
  'action.config.select.variable': 'Variable',

  'action.config.select.And': 'AND',
  'action.config.select.Or': 'OR',

  'action.config.select.rejectRequest': 'Rechazar Solicitud',
  'action.config.select.cancelarSolicitud': 'Cancelar Solicitud',
  'action.config.select.executeAction': 'Ejecutar Acción',
  'action.generate.ai.coming.soon': 'Genera IA Próximamente',
  'action.Enter.some.text.here': 'Introzca algún texto aquí...',
  'action.config.beautify': 'Embellecer',
  'action.config.beautify.loading.title': 'Embelleciendo tu diagrama',
  'action.config.beautify.loading.subtitle':
    'Estamos organizando cada conexión para que el flujo luzca impecable. Solo tomará un momento.',
  'action.config.diagram.loading.title': 'Cargando el diagrama',
  'action.config.diagram.loading.subtitle':
    'Estamos preparando cada acción y conexión para mostrarte el flujo con total claridad.',

  // New fields for all ActionTypes
  'actions.form.process': 'Proceso',
  'actions.form.actionToExecute': 'Acción a Ejecutar',
  'actions.form.sequence': 'Secuencia',
  'actions.form.rpaAgent': 'Agente RPA',
  'actions.form.rpaFlow': 'Flujo RPA',
  'actions.form.integration': 'Integración',
  'actions.form.integrationFunction': 'Función',
  'actions.form.operationType': 'Tipo de Operación',
  'actions.form.model': 'Modelo',
  'actions.form.prompt': 'Prompt',
  'actions.form.additionalInstructions': 'Instrucciones adicionales',
  'actions.form.smsContent': 'Contenido del SMS',
  'actions.form.waitScope': 'Alcance',
  'actions.form.waitStartAction': 'Acción de inicio',
  'actions.form.waitCompletionMode': 'Modo de finalización',
  'actions.form.waitTargetAction': 'Acción objetivo',
  'actions.form.maxWaitTimeUnit': 'Unidad de tiempo máximo de espera',
  'actions.form.maxWaitTimeValue': 'Valor de tiempo máximo de espera',
  'actions.form.waitTimeoutBehavior': 'Comportamiento al agotar el tiempo',
  'actions.form.waitNoChildrenBehavior': 'Comportamiento sin hijos',
  'actions.form.waitChildrenFailureBehavior': 'Comportamiento ante fallo de hijos',
  'actions.form.dependencies': 'Dependencias',
  'actions.form.code': 'Archivo de código',
  'actions.form.serviceType': 'Tipo de Servicio',
  'actions.form.sharePointOperation': 'Tipo de Operación',
  'actions.form.ftpOperationType': 'Tipo de Operación',
  'actions.form.programmingLanguage': 'Lenguaje',
  'actions.form.whatsAppBusinessOperationType': 'Tipo de Operación',

  // DynamicEntityOperation fields
  'actions.form.dynamicEntity': 'Entidad Dinámica',
  'actions.form.dynamicEntityOperation': 'Tipo de Operación',
  'actions.form.searchResultGroupingMode': 'Modo de Agrupación',
  'actions.form.searchResultAllocationMode': 'Modo de Asignación',
  'actions.form.sortField': 'Campo para Ordenar',
  'actions.form.sortDirection': 'Modo de Ordenamiento',
  'actions.form.itemsAffected': 'Elementos Afectados',
  'actions.form.customItemsAffectedNumber': 'Cantidad de Elementos',

  // ScheduledExecution fields
  'actions.form.scheduledExecutionType': 'Tipo de Ejecución Programada',
  'actions.form.delayFrequency': 'Frecuencia de Espera',
  'actions.form.delayFrequencyValue': 'Valor Frecuencia de Espera',
  'actions.form.executionHour': 'Hora de Ejecución',
  'actions.form.executionDayOfWeek': 'Día de La Semana',
  'actions.form.executionMonth': 'Mes de Ejecución',
  'actions.form.executionMonthDay': 'Día del Mes',
  'actions.form.delayUntilFieldValueForm': 'Espera / Formulario',
  'actions.form.delayUntilFieldValueField': 'Espera / Campo',
  'actions.form.delayUntilVariableValueVariable': 'Espera / Variable',

  // ActionScheduledExecutionType
  'actions.form.select.Delay': 'Espera',
  'actions.form.select.DelayUntil': 'Esperar Hasta',
  'actions.form.select.DelayUntilFieldValue': 'Esperar Hasta Valor de Campo',
  'actions.form.select.DelayUntilVariableValue': 'Esperar Hasta Valor de Variable',

  // Validation messages for scheduled execution
  'actions.validation.integerMinValue': 'Debe ser un número entero mayor o igual a {min}',
  'actions.validation.integerRange': 'Debe ser un número entero entre {min} y {max}',

  // FrequencyUnit
  'actions.form.select.Minute': 'Minuto',
  'actions.form.select.Hour': 'Hora',
  'actions.form.select.Day': 'Día',
  'actions.form.select.Month': 'Mes',
  'actions.form.select.BusinessDay': 'Día hábil',

  // DayOfWeek
  'actions.form.select.Sunday': 'Domingo',
  'actions.form.select.Monday': 'Lunes',
  'actions.form.select.Tuesday': 'Martes',
  'actions.form.select.Wednesday': 'Miércoles',
  'actions.form.select.Thursday': 'Jueves',
  'actions.form.select.Friday': 'Viernes',
  'actions.form.select.Saturday': 'Sábado',
  'actions.form.select.Weekend': 'Fin de Semana',
  'actions.form.select.Weekday': 'Día de Semana',

  // MonthName
  'actions.form.select.January': 'Enero',
  'actions.form.select.February': 'Febrero',
  'actions.form.select.March': 'Marzo',
  'actions.form.select.April': 'Abril',
  'actions.form.select.May': 'Mayo',
  'actions.form.select.June': 'Junio',
  'actions.form.select.July': 'Julio',
  'actions.form.select.August': 'Agosto',
  'actions.form.select.September': 'Septiembre',
  'actions.form.select.October': 'Octubre',
  'actions.form.select.November': 'Noviembre',
  'actions.form.select.December': 'Diciembre',

  // ActionOverdueOperation
  'actions.form.select.RejectProcessInstance': 'Rechazar Solicitud',
  'actions.form.select.CancelProcessInstance': 'Cancelar Solicitud',
  'actions.form.select.ExecuteAction': 'Ejecutar Acción',

  // ExternalUserValueSource
  'actions.form.select.FormField': 'Campo de Formulario',
  'actions.form.select.Variable': 'Variable',
  'actions.form.select.FixedValue': 'Valor Fijo',

  // Approval - General
  'actions.form.minApproversCount': 'Mínimo Número de Aprobadores',
  'actions.form.twoFactorApprovalEnabled': '¿Aprobación Two-Factor?',

  // Approval - Rejection
  'actions.form.disableReject': '¿Rechazo Deshabilitado?',
  'actions.form.controlRejection': '¿Control de Rechazo?',
  'actions.form.minRejectionCount': 'Mínimo Número de Rechazos',
  'actions.form.maxRejectionCount': 'Máximo Número de Rechazos',

  // Approval - Deadline
  'actions.form.enabled': '¿Habilitar?',
  'actions.form.delayType': 'Tipo de Ejecución Programada',
  'actions.form.measureUnit': 'Frecuencia de Espera',
  'actions.form.measureValue': 'Valor Frecuencia de Espera',
  'actions.form.delayHour': 'Hora de Ejecución',
  'actions.form.delayDayOfWeek': 'Día de La Semana',
  'actions.form.delayMonthDay': 'Día del Mes',
  'actions.form.delayMonth': 'Mes de Ejecución',
  'actions.form.delayUntilFieldValueForm': 'Espera / Formulario',
  'actions.form.delayUntilFieldValueField': 'Espera / Campo',
  'actions.form.delayUntilVariableValueVariable': 'Espera / Variable',

  // Approval - Filters General
  'actions.form.applicantApprovalEnabled': '¿Aprobar por el Solicitante?',
  'actions.form.approveByApplicantBoss': '¿Aprobar por el Jefe del Solicitante?',
  'actions.form.approveByLastApprover': '¿Aprobar por el Último Aprobador?',
  'actions.form.approveByLastRejectionUser': '¿Aprobar por el Último Rechazador?',
  'actions.form.approveByLastRevisionUser': '¿Aprobar por el Último Revisor?',
  'actions.form.filterByApplicantPosition': '¿Filtrar por Puesto del Solicitante?',
  'actions.form.filterByApplicantArea': '¿Filtrar por Área del Solicitante?',
  'actions.form.filterByApplicantUserGroups': '¿Filtrar por Grupos del Solicitante?',
  'actions.form.allowExternalUserApproval': '¿Habilitar Aprobación por Usuario Externo?',

  // Approval - Filters (Lists)
  'actions.form.users': 'Usuarios',
  'actions.form.positions': 'Puestos',
  'actions.form.areas': 'Áreas',
  'actions.form.userGroups': 'Grupos de Usuarios',
  'actions.form.aiAgents': 'Agentes',

  // External Users
  'actions.form.valueSource': 'Origen',
  'actions.form.sourceForm': 'Formulario',
  'actions.form.sourceField': 'Campo',
  'actions.form.sourceVariable': 'Variable',
  'actions.form.fixedValue': 'Valor Fijo',

  // User Extra Fields
  'actions.form.userExtraField': 'Campo Extra',
  'actions.form.filterValue': 'Valor de Filtro',

  // Global Approvers
  'actions.form.userGroupApprovers': 'Filtro Global de Aprobadores por Grupos de Usuarios',
  'actions.form.userGroupPositionApprovers':
    'Filtro Global de Aprobadores por Grupos de Usuarios y Puestos',
  'actions.form.userGroupAreaApprovers':
    'Filtro Global de Aprobadores por Grupos de Usuarios y Áreas',
  'actions.form.entityUsersApprovers': 'Filtro Global de Aprobadores por Entidades y Usuarios',
  'actions.form.entityPositionUsersApprovers':
    'Filtro Global de Aprobadores por Entidades y Puestos',
  'actions.form.entityAreaUsersApprovers': 'Filtro Global de Aprobadores por Entidades y Áreas',
  'actions.form.entityUserGroupUsersApprovers':
    'Filtro Global de Aprobadores por Entidades y Grupos de Usuarios',
  'actions.form.approvalLevelEnabled': '¿Habilitar Nivel de Filtro?',
  'actions.form.approvalLevel': 'Nivel de Filtro',
  'actions.form.field': 'Campo',

  // Form Field User Approvers
  'actions.form.userApprovers': 'Filtro de Usuario por Campo de Formulario',
  'actions.form.positionApprovers': 'Filtro de Usuario por Campo Puesto de Formulario',
  'actions.form.areaApprovers': 'Filtro de Usuario por Campo Área de Formulario',
  'actions.form.userGroupApprovers': 'Filtro de Usuario por Campo Grupo de Usuarios de Formulario',

  // LogicalOperator
  'actions.form.select.Or': 'O',
  'actions.form.select.And': 'Y',

  'action.canvas.zoomIn': 'Acercar',
  'action.canvas.pan': 'Mover lienzo',
  'action.canvas.select': 'Seleccionar elementos',
  'action.canvas.zoomLabel': 'Zoom',
};
